import { SupplyOptions } from '@core/constants';
import { createReducer, on } from '@ngrx/store';

import { SameDayState } from './interfaces/same-day-interface';
import {
  ClearSameDay,
  SetSameDayAdditionalSupplies,
  SetSameDayAdditionalDocuments,
  SetSameDayBilling,
  SetSameDayDestination,
  SetSameDayInsurance,
  SetSameDayIsOriginDestinationValid,
  SetSameDayNotificationSettings,
  SetSameDayOrigin,
  SetSameDayScheduling,
  SetSameDayShipmentContents,
  SetSameDayShipmentIdentifiers,
  SetSameDaySpecialInstructions,
  SetSameDaySupplies,
} from './same-day-courier.actions';

export const sameDayInitialState: SameDayState = {
  shipment: {
    origin: {
      value: {},
      valid: false,
    },
    destination: {
      value: {},
      valid: false,
    },
    isOriginDestinationValid: { valid: false },
    scheduling: {
      value: { pickedUpSpecificTime: true, arriveBySpecificDate: false },
      valid: false,
    },
    contents: {
      value: {},
      valid: false,
    },
    billing: {
      value: {},
      valid: false,
    },
  },
  options: {
    insurance: { value: {}, valid: true },
    supplies: {
      value: { supplyMaterialsNeeded: false, trackerType: SupplyOptions.NONE },
      valid: true,
    },
    additionalSupplies: { value: {}, valid: true },
    additionalDocuments: { value: [], valid: true },
    shipmentIdentifier: { value: {}, valid: false },
    specialInstructions: { value: '', valid: true },
    notificationSettings: { value: [], valid: true },
  },
};

export const sameDayCourierReducer = createReducer(
  sameDayInitialState,
  on(SetSameDayOrigin, (state, { valid, value }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        origin: {
          value,
          valid,
        },
      },
    };
  }),
  on(SetSameDayDestination, (state, { valid, value }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        destination: {
          value,
          valid,
        },
      },
    };
  }),
  on(SetSameDayIsOriginDestinationValid, (state, { valid }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        isOriginDestinationValid: {
          valid,
        },
      },
    };
  }),
  on(SetSameDayScheduling, (state, { valid, value }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        scheduling: {
          value,
          valid,
        },
      },
    };
  }),
  on(SetSameDayShipmentContents, (state, { valid, value }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        contents: {
          value,
          valid,
        },
      },
    };
  }),
  on(SetSameDayNotificationSettings, (state, { valid, value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        notificationSettings: {
          value: value,
          valid,
        },
      },
    };
  }),
  on(SetSameDayInsurance, (state, { valid, value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        insurance: {
          value: value,
          valid,
        },
      },
    };
  }),
  on(SetSameDaySpecialInstructions, (state, { value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        specialInstructions: {
          value,
          valid: true,
        },
      },
    };
  }),
  on(SetSameDayShipmentIdentifiers, (state, { value, valid }) => {
    return {
      ...state,
      options: {
        ...state.options,
        shipmentIdentifier: {
          value,
          valid,
        },
      },
    };
  }),
  on(SetSameDaySupplies, (state, { value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        supplies: {
          value,
          valid: true,
        },
      },
    };
  }),
  on(SetSameDayAdditionalSupplies, (state, { value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        additionalSupplies: {
          value,
          valid: true,
        },
      },
    };
  }),
  on(SetSameDayAdditionalDocuments, (state, { value }) => {
    return {
      ...state,
      options: {
        ...state.options,
        additionalDocuments: {
          value,
          valid: true,
        },
      },
    };
  }),
  on(SetSameDayBilling, (state, { value }) => {
    return {
      ...state,
      shipment: {
        ...state.shipment,
        billing: {
          value,
          valid: !!value?.siteId,
        },
      },
    };
  }),
  on(ClearSameDay, () => {
    return sameDayInitialState;
  })
);
